import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FastBackwardOutlinedSvg from "@ant-design/icons-svg/es/asn/FastBackwardOutlined";
import AntdIcon from "../components/AntdIcon";
var FastBackwardOutlined = function FastBackwardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FastBackwardOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FastBackwardOutlined.displayName = 'FastBackwardOutlined';
}
export default /*#__PURE__*/React.forwardRef(FastBackwardOutlined);